export default class LocalStorageUtil {
    public static getThemeConfigurationValue(config: string): boolean {
        const themeValue = localStorage.getItem(config);

        return (themeValue === null) ? false : JSON.parse(themeValue);
    }
}
